// Decodes Riftbound/LoR deck codes.
// Based on https://github.com/RiotGames/LoRDeckCodes

const BASE32_ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567';

const SET_NAMES = ['OGN', 'OGS', 'SFD', 'UNL'];

class DeckCodeDecoder {
  constructor(code) {
    this.code = code.trim().toUpperCase();
    this.bits = [];
    this.pos = 0;
  }

  _init() {
    if (this.bits.length > 0) return;
    for (const char of this.code) {
      const val = BASE32_ALPHABET.indexOf(char);
      if (val >= 0) {
        for (let i = 4; i >= 0; i--) this.bits.push((val >> i) & 1);
      }
    }
  }

  _readBits(n) {
    this._init();
    let value = 0;
    for (let i = 0; i < n; i++) {
      value = (value << 1) | (this.pos < this.bits.length ? this.bits[this.pos] : 0);
      this.pos++;
    }
    return value;
  }

  _readVarInt() {
    let value = 0;
    let shift = 0;
    while (true) {
      const byte = this._readBits(8);
      value |= (byte & 0x7F) << shift;
      if ((byte & 0x80) === 0) break;
      shift += 7;
    }
    return value;
  }

  decode() {
    this._init();

    if (this.bits.length < 8) return null;

    const format = this._readBits(4);
    const version = this._readBits(4);

    const result = { format, version, cards: [] };

    let factionCount = 0;
    if (format > 1) {
      factionCount = this._readVarInt();
    }

    for (let f = 0; f < (format > 1 ? factionCount : 3); f++) {
      const cardCount = format > 1 ? this._readVarInt() : this._readBits(8);
      if (cardCount === 0 && format <= 1) continue;

      const factionId = format > 1 ? this._readVarInt() : 0;

      for (let c = 0; c < cardCount; c++) {
        const set = format > 1 ? this._readVarInt() : this._readBits(4);
        const fac = format > 1 ? this._readVarInt() : this._readBits(4);
        const num = format > 1 ? this._readVarInt() : this._readBits(8);
        const qty = format > 1 ? this._readVarInt() : this._readBits(4);

        if (qty > 0 && qty <= 3) {
          result.cards.push({ set, faction: fac, cardNum: num, count: qty });
        }
      }
    }

    return result;
  }
}

function setCodeFromNumber(num) {
  return SET_NAMES[num] || `SET${num}`;
}

export function decodeDeckCode(code) {
  try {
    const decoder = new DeckCodeDecoder(code);
    const result = decoder.decode();
    if (!result) return null;

    const cards = result.cards.map(c => ({
      id: `${setCodeFromNumber(c.set)}-${String(c.cardNum).padStart(3, '0')}`,
      count: c.count,
    }));

    return { ...result, cards };
  } catch {
    return null;
  }
}

export function isDeckCode(text) {
  if (!text || text.length < 10) return false;
  const trimmed = text.trim().toUpperCase();
  return [...trimmed].every(c => BASE32_ALPHABET.includes(c));
}
